import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

// Réécrit les anciennes URLs servitechxpert.com (images/PDF) vers le stockage objet,
// UNIQUEMENT pour les réponses publiques /shop/ (n'affecte pas les formulaires admin).
// Rend le storefront de PRODUCTION fonctionnel même si sa base contient encore les vieilles URLs.
const OLD_ASSET_RE = /https?:\/\/servitechxpert\.com\/[^\s"'<>)\\]+?\.(?:jpe?g|png|gif|webp|pdf)(?:\?[^\s"'<>)\\]*)?/gi;
// Ne PAS réécrire les fichiers déjà hébergés sur le stockage objet actuel (/api/files/),
// même s'ils portent le domaine de production. Seuls les vrais anciens liens WP sont réécrits.
const rewriteLegacy = (s) => s.replace(OLD_ASSET_RE, (m) => (m.indexOf("/api/files/") !== -1 || m.indexOf("/legacy-file") !== -1 ? m : `${API}/legacy-file?u=${encodeURIComponent(m)}`));
const deepRewriteLegacy = (v) => {
  if (typeof v === "string") return v.indexOf("servitechxpert.com") !== -1 ? rewriteLegacy(v) : v;
  if (Array.isArray(v)) return v.map(deepRewriteLegacy);
  if (v && typeof v === "object") { for (const k in v) v[k] = deepRewriteLegacy(v[k]); return v; }
  return v;
};
axios.interceptors.response.use((res) => {
  try {
    const url = res.config && res.config.url ? res.config.url : "";
    if ((url.indexOf("/shop/") !== -1 || url.indexOf("/vendor/") !== -1) && res.data) res.data = deepRewriteLegacy(res.data);
  } catch (e) { /* noop */ }
  return res;
});

// Rend une image affichable dans le back-office : les anciennes URLs servitechxpert.com
// passent par le proxy /legacy-file (les fichiers /api/files/ et récents restent tels quels).
export const assetSrc = (url) => {
  if (!url || typeof url !== "string") return url;
  if (url.indexOf("/api/files/") !== -1 || url.indexOf("/legacy-file") !== -1) return url;
  if (url.indexOf("servitechxpert.com") !== -1) return `${API}/legacy-file?u=${encodeURIComponent(url)}`;
  return url;
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  useEffect(() => {
    axios
      .get(`${API}/auth/me`)
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data);
    return data;
  };

  const register = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/register-client`, { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (e) {
      console.error("Logout request failed:", e);
    }
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await axios.get(`${API}/auth/me`);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export { API };
